import React  from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { notification } from 'antd';

export function objectWitOnlyProperties(obj, keys)
{ 
    var target = {}; 
    for (var i in obj) 
    { 
        if (keys.indexOf(i) < 0) 
            continue; 
                
        target[i] = obj[i]; 
     } 

     return target; 
}

export function TrimNan(value)
{
  if (value === undefined || isNaN(value))
  {
    return 0;
  }
  else
  {
    return value;
  }
}

export function getSafeArray(value)
{
  if (undefined === value)  
  {
    return [];
  }
  else if (!(value instanceof Array))
  {
    return [];
  }
  
  return value;
}

export function DeviceStatusToString(value)
{
  if ( value === undefined)
  {
      return "";
  }

  var result = "Unknown";

  if (value === 0)
  {
    result = "OK";
  }
  else if (value === 1)
  {
    result = "PAUSED";
  }
  else if (value === 2)
  {
    result = "ERROR";
  } 
  else if (value === 4)
  {
    result = "PENDING DELETION";
  }
  else if (value === 8)
  {
    result = "PAPER JAM";
  }
  else if (value === 16)
  {
    result = "PAPER OUT";
  }
  else if (value === 32)
  {
    result = "MANUAL FEED";
  }
  else if (value === 64)
  {
    result = "PAPER PROBLEM";
  }
  else if (value === 128)
  {
    result = "OFFLINE";
  }
  else if (value === 256)
  { 
    result = "IO ACTIVE";
  }
  else if (value === 512)
  { 
    result = "BUSY";
  }
  else if (value === 1024)
  { 
    result = "PRINTING";
  }
  else if (value === 2048)
  { 
    result = "OUTPUT BIN FULL";
  }
  else if (value === 4096)
  { 
    result = "NOT AVAILABLE";
  }
  else if (value === 8192)
  { 
    result = "WAITING";
  }
  else if (value === 16384)
  { 
    result = "PROCESSING";
  }
  else if (value === 32768)
  { 
    result = "INITIALIZING";
  }
  else if (value === 65536)
  { 
    result = "WARMING UP";
  }
  else if (value === 131072)
  { 
    result = "TONER LOW";
  }
  else if (value === 262144)
  { 
    result = "NO TONER";
  }
  else if (value === 524288)
  { 
    result = "PAGE PUNT";
  }
  else if (value === 1048576)
  { 
    result = "USER INTERVENTION";
  }
  else if (value === 2097152)
  { 
    result = "OUT OF MEMORY";
  }
  else if (value === 4194304)
  { 
    result = "DOOR OPEN";
  }
  else if (value === 8388608)
  { 
    result = "SERVER UNKNOWN";
  }
  else if (value === 16777216)
  { 
    result = "POWER SAVE";
  }
  else if (value === 33554432)
  { 
    result = "SERVER OFFLINE";
  }
  else if (value === 67108864)
  { 
    result = "DRIVER UPDATE NEEDED";
  }

  return result;
}

export function getCurrentSupplyLevel(value){
  var result = {
      current_level : 100,
      use_level_value : true
  };
  
  if (value.level === -3)
  {
      result.use_level_value = false;
      result.current_level = "OK";
  }
  else if (value.level >= 0 && value.maxCapacity > 0)
  {
      result.current_level = Math.round(100 * (value.level / value.maxCapacity));
  }
  else if (value.level === value.maxCapacity)
  {
    result.current_level = 100;
  }
  else
  {
      result.use_level_value = false;
      result.current_level = "Unknown";
  }

  result.current_level = result.use_level_value ? result.current_level + '%' : result.current_level

  return result;
}

export function drawSupply(row)
{
  var value = {
      level : row.level,
      maxCapacity : row.maxCapacity,
      color : row.color === undefined ? "lightgray" : row.color
  };

  var result = getCurrentSupplyLevel(value);
  var backgroundColor = result.use_level_value ? value.color : "#ffffff";
  
  return (<div
     style={{
     width: "100%",
     height: "100%",
     backgroundColor: "#fff",
     borderRadius: "0px"
     }}
     >
     <div
     style={{
         width: result.use_level_value ? `${result.current_level}` : "100%",
         height: "100%",
         overflowWrap: 'normal',
         backgroundColor: `${backgroundColor}`,
         borderRadius: "1px",
         transition: "all .2s ease-out",
         color: `${backgroundColor}` === "#000000" && `${result.current_level}` !== "0%" ? "darkgray" : "black",
         verticalAlign: "middle"
     }}
     ><i>{result.current_level}</i></div>
 </div>)
  }

  export function getPeriodDescription(period){
    if ( period === undefined)
    {
        return "Unknown";
    }
    else if (period === 0)
    {
        return "Period.Job";
    }
    else if ( period === 1)
    {
        return "Period.EveryDay";
    }
    else if ( period === 2)
    {
        return "Period.EveryWeek";
    }
    else if ( period === 3)
    {
        return "Period.EveryMonth";
    }
    else if ( period === 4)
    {
        return "Period.Manual";
    }
    else if ( period === 5)
    {
        return "Period.EveryHour";
    }
    else if ( period === 7)
    {
        return "Period.ProgramEvent";
    }

    return "Unknown";
  }

  export function getReportType(url)
  {
    var report_url = url.toLowerCase();
    var index = url.indexOf('?');
    if ( index !== -1)
    {
      report_url = report_url.substring(0 , index);
    }

    if (report_url === '/printers_supplies')
    {
        return "Report.Consumables";
    }
    else if (report_url === '/printers_values')
    {
        return 'Report.Meters';
    }
    else if (report_url.search('/printer_supplies_') === 0)
    {
        return 'Report.ChangeDeviceConsumables';
    }
    else if (report_url === '/printer_status')
    {
        return 'Report.ChangeDeviceStatus';
    }
    else if (report_url === '/job')
    {
        return 'Report.DocumentPrinted';
    }
    else if (report_url === '/jobs')
    {
        return 'Report.PrintedJobs';
    }
    else if (report_url === '/printers' || report_url === '/users' || report_url === '/computers' || report_url === '/groups')
    {
        return 'Report.Summary';
    }
    else if (report_url === '/printer' || report_url === '/user' || report_url === '/computer' || report_url === '/group')
    {
        return 'Report.Detailed';
    }

    return "Report.Consumables";
  }

 export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    
    if (!results) 
      return null;
    if (!results[2]) 
      return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCurrencySymbol(locale_code) {
  if (!locale_code || typeof locale_code !== 'string') {
    return 'EUR';
  }

  const locale = locale_code.toLowerCase();

  // Россия и русскоязычные регионы
  if (locale.startsWith('ru')) {
    return 'RUB';
  }

  // Китай
  if (locale.startsWith('zh')) {
    return 'CNY';
  }

  // Япония
  if (locale.startsWith('ja')) {
    return 'JPY';
  }

  // Корея
  if (locale.startsWith('ko')) {
    return 'KRW';
  }

  // Индия (хинди, английский Индии)
  if (locale.startsWith('hi') || locale === 'en-in') {
    return 'INR';
  }

  // Английский (по умолчанию считаем USD)
  if (locale.startsWith('en')) {
    return 'USD';
  }

  // Всё остальное — Европа
  return 'EUR';
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function isColorToString(value) {
  if (value === 2)
  {
    return "Yes";
  }
  else
  {
    return "No";
  }
}

export function isDuplexToString(value) {
  if (value === 2 || value === 3)
  {
    return "Yes";
  }
  else
  {
    return "No";
  }
}

export function compareStrings(a, b) {

    if (a === b) {
        return 0;
    }
    else if (!a) {
        return 1;
    }
    else if (!b) {
        return -1;
    }
    else { 
        return a.localeCompare(b);
    }
}

export function sendPost(url, object, intl) {
 
  axios.post(url, object)
  .then(response => {
    notification['success']({
      message: intl.formatMessage({id:'Success'}),
      description: intl.formatMessage({id: 'Success_result'}),
    });
  })
  .catch(err => {
    notification['error']({
      message: intl.formatMessage({id: 'Error'}),
      description: err.message,
      duration: 0
    });
  });
}

export async function sendSyncPost(url, object, intl) {
  try
  {
    await axios.post(url, object);

    notification['success']({
      message: intl.formatMessage({id:'Success'}),
      description: intl.formatMessage({id: 'Success_result'}),
    });
  }
  catch (err) 
  {
    notification['error']({
      message: intl.formatMessage({id: 'Error'}),
      description: err.message,
      duration: 0
    });
  }
}

export async function calculateSHA256(inputString) {
  try {
    const encoder = new TextEncoder();
    const data = encoder.encode(inputString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
  } catch (error) {
    console.error('Error calculating hash:', error);
    return null;
  }
};

export function getDateRange(newType) {
    const now = dayjs();

    switch (newType) {
        case 'today':
        {
            return {
                fromDate: now.startOf('day'),
                toDate: now.endOf('day'),
            };
        }

        case 'yesterday':
        {
            const y = now.subtract(1, 'day');
            return {
                fromDate: y.startOf('day'),
                toDate: y.endOf('day'),
            };
        }

        case 'lastWeek':
        {
            const w = now.subtract(1, 'week');
            return {
                fromDate: w.startOf('week'),
                toDate: w.endOf('week'),
            };
        }

        case 'lastMonth':
        {
            const m = now.subtract(1, 'month');
            return {
                fromDate: m.startOf('month'),
                toDate: m.endOf('month'),
            };
        }

        case 'last7days':
        {
            return {
                fromDate: now.subtract(7, 'day'),
                toDate: now.endOf('day'),
            };
        }

        case 'last30days':
        {
            return {
                fromDate: now.subtract(30, 'day'),
                toDate: now.endOf('day'),
            };
        }

        default:
        case 'thisYear':
        {
            return {
                fromDate: now.startOf('year'),
                toDate: now.endOf('day'),
            };
        }
    }
}